import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import * as unlockCardsActions from 'store/modules/unlockCards/actions'
import { get, omit } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import { Container, Form, Row, Col, Button, Spinner } from 'react-bootstrap'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import MaskedInput from 'react-maskedinput'
import { DateTime } from 'luxon'
import ptBR from 'date-fns/locale/pt-BR'
import { cpfMask, numberMask, phoneMask, codeMask, cepMask } from 'helpers/strings'
import { cpf } from 'cpf-cnpj-validator'

import If from 'components/atoms/If'
import Typography from 'components/atoms/Typography'
import CustomButton from 'components/atoms/CustomButton'
import CustomModal from 'components/molecules/CustomModal'
import Input from 'components/atoms/Input'

import 'react-datepicker/dist/react-datepicker.css'
import 'styles/datepicker.scss'
import './DesbloqueioCartao.scss'

setDefaultLocale('pt-BR')
registerLocale('pt-BR', ptBR)

function DesbloqueioCartao(props) {
  const { data, user } = props
  const myRef = useRef(null)
  const title = get(data, 'title')
  const description = get(data, 'description.value')

  const dispatch = useDispatch()
  const cardsList = useSelector((state) => state.unlockCards.cards)
  const cardRecipient = useSelector((state) => state.unlockCards.cardRecipient)
  const loadingCardRecipent = useSelector((state) => state.unlockCards.loadingCardRecipent)

  const updateCardRecipient = useSelector((state) => state.unlockCards.updateCardRecipient)
  const loadingUpdatedCardRecipient = useSelector((state) => state.unlockCards.loadingUpdatedCardRecipient)
  const errorUpdateCardRecipient = useSelector((state) => state.unlockCards.errorUpdateCardRecipient)

  const loadingCardsUnlock = useSelector((state) => state.unlockCards.loadingCardsUnlock)
  const errorCardsUnlock = useSelector((state) => state.unlockCards.errorCardsUnlock)
  const searchZipCode = useSelector((state) => state.unlockCards.searchZipCode)
  const loadingSearchZipCode = useSelector((state) => state.unlockCards.loadingSearchZipCode)
  const errorSearchZipCode = useSelector((state) => state.unlockCards.errorSearchZipCode)
  const [modalZipCodeOpened, setModalZipCodeOpened] = useState(false)
  const [zipCodeList, setZipCodeList] = useState([])

  // const [birthdayDate, setBirthdayDate] = useState(new Date(1976, 11, 27))
  // const [validityDate, setValidityDate] = useState(new Date(2023, 3, 9))
  // const [cardNumber, setCardNumber] = useState(codeMask('00320000075219204'))
  // const [cpfNumber, setCpfNumber] = useState(cpfMask('02497599939'))

  const [birthdayDate, setBirthdayDate] = useState(new Date())
  const [validityDate, setValidityDate] = useState(new Date())
  const [cardNumber, setCardNumber] = useState('0 032 00000')
  const [cpfNumber, setCpfNumber] = useState('')

  const [message, setMessage] = useState('')

  const [cardRecipientData, setCardRecipientData] = useState({
    name: '',
    handleRecipient: '',
    handleCard: '',
    handleRegistration: '',
    code: '',
    type: '',
    dependentType: '',
    blocked: '',
    nameMother: '',
    cpf: '',
    email: '',
    address: {
      zipcode: '',
      handleResidential: '',
      handleMail: '',
      street: '',
      neighborhood: '',
      city: '',
      state: '',
      number: '',
      complement: '',
      handleState: '',
      handleCity: '',
      phoneDDD: '',
      phone: '',
      phonePrefix: '',
      phoneNumber: '',
      cellPhone: '',
      cellPhoneDDD: '',
      cellPhonePrefix: '',
      cellPhoneNumber: '',
    },
  })

  const [checkCardStep, setCheckCardStep] = useState(true)
  const [checkFormStep, setCheckFormStep] = useState(false)
  const [modalOpened, setModalOpened] = useState(false)

  const [selectedCard, setSelectedCard] = useState(false)

  const [formValidated, setFormValidated] = useState(false)
  const [formSaveValidated, setFormSaveValidated] = useState(false)

  const updateCardNumber = (e) => {
    if (e.target.value === '' || e.target.value === '0 032 00000') {
      e.target.value = '0 032 00000'
      if (e.type === 'keypress') {
        e.target.setSelectionRange(11, 0)
        e.preventDefault()
        e.stopPropagation()
      }
    }
    setCardNumber(e.target.value)
  }

  const handleSubmit = (e) => {
    const form = e.currentTarget
    if (form.checkValidity() && cpf.isValid(numberMask(cpfNumber))) {
      checkCard()
    }
    setFormValidated(true)
    e.preventDefault()
    e.stopPropagation()
  }

  const handleSave = (e) => {
    const form = e.currentTarget
    let isValid = true
    if (validateFields(form)) {
      saveCard()
    } else {
      isValid = false
    }

    setFormSaveValidated(true)

    e.preventDefault()
    e.stopPropagation()

    if (!isValid) {
      return false
    }
  }

  const validateFields = (form) => {
    return (
      form.checkValidity() &&
      cpf.isValid(numberMask(cardRecipientData.cpf)) &&
      isEmailValid() &&
      !isInvalidPhone() &&
      !isInvalidPhoneDDD() &&
      !isInvalidCellPhoneNumber() &&
      !isInvalidCellPhoneDDD() &&
      cardRecipientData?.address?.street &&
      cardRecipientData?.address?.number &&
      cardRecipientData?.address?.city &&
      cardRecipientData?.address?.state &&
      cardRecipientData?.address?.neighborhood &&
      cepMask(cardRecipientData?.address?.zipcode)?.length == 9 &&
      !isInvalidNameMother()
    )
  }

  const isInvalidPhone = () => {
    const phone = cardRecipientData?.address?.phone
    const ddd = cardRecipientData?.address?.phoneDDD

    return (
      (numberMask(phone).length > 0 || (ddd && ddd.length > 0)) &&
      (numberMask(phone).length !== 8 || numberMask(phone)[0] < 1 || numberMask(phone)[0] > 6)
    )
  }

  const isInvalidPhoneDDD = () => {
    const phone = cardRecipientData?.address?.phone
    const ddd = cardRecipientData?.address?.phoneDDD

    return ((ddd && ddd.length > 0) || (phone && phone.length > 0)) && (ddd < 11 || ddd > 99)
  }

  const renderCardsList = (cardList) => {
    if (cardList) {
      return cardList.map((card) => {
        return (
          <li key={card.handle} className="unlock-card__dependent mb-3">
            <span onClick={() => checkDependent(card)}> {card.name}</span>
            {card.blocked ? (
              <span onClick={() => checkDependent(card)} className="icone-acoes-lock ml-2" title="Desbloquear cartão">
                <i className="icone-lock"></i>
              </span>
            ) : (
              <span onClick={() => checkDependent(card)} title="Cartão desbloqueado">
                {' '}
                - Desbloqueado
              </span>
            )}
          </li>
        )
      })
    }
  }

  const checkCard = () => {
    const formattedValidityDate = DateTime.fromJSDate(validityDate).toFormat('yyyy-MM-dd')
    const formattedBirthdayDate = DateTime.fromJSDate(birthdayDate).toFormat('yyyy-MM-dd')

    if (cpf.isValid(numberMask(cpfNumber))) {
      const cardData = {
        cardNumber: numberMask(cardNumber),
        expirationDate: formattedValidityDate,
        birthDate: formattedBirthdayDate,
        cpf: numberMask(cpfNumber),
      }
      dispatch(unlockCardsActions.getCards(cardData))
      setCheckCardStep(false)
    } else {
      setMessage('O CPF informado é inválido. Favor verificar os dados informados e tentar novamente.')
      setModalOpened(true)
    }
  }

  const splitPhone = (string, type) => {
    let phone = string.split('-')
    if (phone.length >= type + 1) {
      return numberMask(phone[type])
    } else {
      return ''
    }
  }

  const saveCard = () => {
    let temp = {
      ...cardRecipientData,
      address: {
        ...omit(cardRecipientData.address, ['phone', 'cellPhone'], cardRecipientData),
        phonePrefix: splitPhone(cardRecipientData.address.phone, 0),
        phoneNumber: splitPhone(cardRecipientData.address.phone, 1),
        cellPhonePrefix: splitPhone(cardRecipientData.address.cellPhone, 0),
        cellPhoneNumber: splitPhone(cardRecipientData.address.cellPhone, 1),
      },
      blocked: true,
      code: numberMask(cardRecipientData.code),
      cpf: numberMask(cardRecipient.cpf),
    }
    const cardData = {
      input: temp,
      handle: selectedCard.handle,
    }
    dispatch(unlockCardsActions.updateCardRecipient(cardData))
  }

  const checkDependent = (card) => {
    if (card.blocked) {
      setSelectedCard(card)
      const cardData = {
        handle: card.handle,
      }
      dispatch(unlockCardsActions.getCardRecipient(cardData))
    } else {
      setMessage('Este cartão já se encontra desbloqueado')
      setModalOpened(true)
    }
  }

  const handleEdit = (prop, value) => {
    let tmp = {
      ...cardRecipientData,
    }
    props = prop.split('.')

    if (prop === 'cpf') {
      value = cpfMask(value)
    } else if (prop === 'code') {
      value = codeMask(value)
    } else if (prop === 'address.phoneDDD' || prop === 'address.cellPhoneDDD') {
      value = numberMask(value)
    } else if (prop === 'address.phone' || prop === 'address.cellPhone') {
      value = phoneMask(value)
    }

    if (props.length > 1) {
      tmp[props[0]][props[1]] = value
    } else {
      tmp[prop] = value
    }
    setCardRecipientData(tmp)
  }

  const searchCep = () => {
    if (loadingSearchZipCode) {
      return false
    }
    if (cardRecipientData.address.zipcode) {
      let searchData = {
        zipcode: cardRecipientData.address.zipcode,
      }
      dispatch(unlockCardsActions.searchZipCode(searchData))
    }
  }

  useEffect(() => {
    if (!loadingCardsUnlock && errorCardsUnlock) {
      setMessage('Cartão não encontrado. Verifique os dados e tente novamente.')
      setModalOpened(true)
      setCheckCardStep(true)
    }
  }, [cardsList, errorCardsUnlock, loadingCardsUnlock])

  useEffect(() => {
    if (cardRecipient && cardRecipient.address) {
      let temp = {
        ...cardRecipient,
      }
      temp.code = codeMask(cardRecipient.code)
      temp.cpf = cpfMask(cardRecipient.cpf)
      temp.address.phone =
        cardRecipient.address.phoneNumber && cardRecipient.address.phonePrefix
          ? cardRecipient.address.phonePrefix + '-' + cardRecipient.address.phoneNumber
          : ''
      temp.address.cellPhone =
        cardRecipient.address.cellPhoneNumber && cardRecipient.address.cellPhonePrefix
          ? cardRecipient.address.cellPhonePrefix + '-' + cardRecipient.address.cellPhoneNumber
          : ''
      setCardRecipientData(temp)
      setCheckFormStep(true)
    }
  }, [cardRecipient])

  useEffect(() => {
    if (updateCardRecipient) {
      setMessage('Beneficiário desbloqueado!')
      checkCard()
      if (myRef.current !== null) {
        myRef.current.scrollIntoView()
      }
      setCheckFormStep(false)
      setModalOpened(true)
    } else {
      if (!loadingUpdatedCardRecipient && errorUpdateCardRecipient) {
        setMessage('Ocorreu um erro, favor entrar em contato com o atendimento Unimed.')
        setModalOpened(true)
      }
    }
  }, [updateCardRecipient, errorUpdateCardRecipient, loadingUpdatedCardRecipient])

  useEffect(() => {
    if (errorSearchZipCode) {
      setMessage('O CEP informado não foi encontrado. Verifique os dados e tente novamente')
      setModalOpened(true)
    } else {
      if (searchZipCode) {
        setZipCodeList([])
        setModalZipCodeOpened(false)
        const addresses = searchZipCode.zipcodeList.addresses
        if (addresses.length == 1) {
          setCardRecipientData({
            ...cardRecipientData,
            address: {
              ...cardRecipientData.address,
              city: addresses[0].locale,
              state: addresses[0].state,
              street: addresses[0].street,
              neighborhood: addresses[0].neighborhood,
              number: '',
              complement: '',
            },
          })
        } else {
          const tempZipCodeList = []
          const aux = []

          addresses.forEach((item) => {
            const addObj = {
              street: item.street ? item.street.trim() : '',
              neighborhood: item.neighborhood ? item.neighborhood.trim() : '',
              locale: item.locale ? item.locale.trim() : '',
              state: item.state ? item.state.trim() : '',
            }
            const strAux = addObj.street + addObj.neighborhood + addObj.locale + addObj.state
            if (aux.indexOf(strAux) < 0) {
              tempZipCodeList.push(addObj)
              aux.push(strAux)
            }
          })

          setZipCodeList(tempZipCodeList)
          setModalZipCodeOpened(true)
        }
      }
    }
  }, [searchZipCode, errorSearchZipCode])

  const setSelectedZipCode = (index) => {
    setCardRecipientData({
      ...cardRecipientData,
      address: {
        ...cardRecipientData.address,
        city: zipCodeList[index].locale,
        state: zipCodeList[index].state,
        street: zipCodeList[index].street,
        neighborhood: zipCodeList[index].neighborhood,
        number: '',
        complement: '',
      },
    })
    setModalZipCodeOpened(false)
  }

  useEffect(() => {
    setModalOpened(false)
    setModalZipCodeOpened(false)
  }, [])

  const validRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  const isEmailValid = () => {
    if (!cardRecipientData.email) {
      return true
    }
    return validRegex.test('' + cardRecipientData.email)
  }

  const isEmailInvalid = !cardRecipientData.email ? false : !validRegex.test('' + cardRecipientData.email)

  const isInvalidCellPhoneNumber = () => {
    const ddd = cardRecipientData.address.cellPhoneDDD
    const number = cardRecipientData.address.cellPhone
    return (
      ((number && numberMask(number).length > 0) || (ddd && ddd.length)) &&
      (numberMask(number).length !== 9 || numberMask(number)[0] < 7)
    )
  }

  const isInvalidCellPhoneDDD = () => {
    const ddd = cardRecipientData.address.cellPhoneDDD
    const number = cardRecipientData.address.cellPhone
    return ((ddd && ddd.length > 0) || (number && number.length > 0)) && (ddd < 11 || ddd > 99)
  }

  const isInvalidNameMother = () => {
    const nameMother = cardRecipientData?.nameMother.toString().trim()
    return !(nameMother && nameMother.split(' ').length > 1)
  }

  return (
    <div className="unlock-card">
      <Container className="my-5 unlock-card" ref={myRef}>
        <Row>
          <Col>
            <Typography variant="h2" color="primary" cssClass="title-semibold-md mb-3">
              {title}
            </Typography>
            {description && (
              <Typography component="" color="gray-100" cssClass="bloco-conteudo-text mb-4">
                {ReactHtmlParser(description)}
              </Typography>
            )}
          </Col>
        </Row>
        {loadingCardsUnlock ? (
          <Row className="justify-content-md-center my-5">
            <Col md="auto" className="text-center">
              <Spinner animation="border" />
            </Col>
          </Row>
        ) : (
          <If condition={cardsList && !checkCardStep}>
            <Row>
              <Col>
                <Typography cssClass="mb-3" variant="p" color="gray-100">
                  Prezado cliente, clique no cadeado para dar continuidade na alteração e desbloqueio de seu cartão
                </Typography>

                <div className="unlock-card__dependents">
                  <ul>{renderCardsList(cardsList)}</ul>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <CustomButton
                  text="Voltar"
                  icon="arrow-left"
                  onClick={() => {
                    setCheckFormStep(false)
                    setCheckCardStep(true)
                  }}
                />
              </Col>
            </Row>
          </If>
        )}

        <If condition={checkCardStep}>
          <Row>
            <Col>
              <Typography cssClass="mb-3 mt-4" variant="p" color="gray-100">
                Preencha os campos com seus dados:
              </Typography>
            </Col>
          </Row>
          <Form noValidate validated={formValidated} onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col xs={12} lg={3} md="auto" className="mb-3 mb-lg-0">
                <Form.Group controlId="formCardNumber">
                  <Form.Label>Número do Cartão:</Form.Label>
                  <Form.Control
                    type="text"
                    as={MaskedInput}
                    value={cardNumber}
                    maxLength={20}
                    required={true}
                    mask="0 032 000001111111 1"
                    placeholder="0 032 00000_______ _"
                    onFocus={(e) => updateCardNumber(e)}
                    onChange={(e) => updateCardNumber(e)}
                    onKeyUp={(e) => updateCardNumber(e)}
                  />
                  <Form.Control.Feedback type="invalid">Por favor, informe o número do cartão</Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col xs={12} lg={3}>
                <Form.Group controlId="formValidityDate">
                  <Form.Label>Data de validade:</Form.Label>
                  <div>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={validityDate || new Date()}
                      required={true}
                      onChange={(date) => setValidityDate(date)}
                      customInput={<MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" />}
                    />
                  </div>
                  <Form.Control.Feedback type="invalid">
                    Por favor, informe a data de validade do cartãoo
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} lg={3} md="auto" className="mb-3 mb-lg-0">
                <Form.Group controlId="formCpfNumber">
                  <Form.Label>CPF:</Form.Label>
                  <Form.Control
                    type="text"
                    as={MaskedInput}
                    mask="111.111.111-11"
                    placeholder="___.___.___-__"
                    value={cpfNumber}
                    required={true}
                    isInvalid={cpfNumber.length > 0 && !cpf.isValid(numberMask(cpfNumber))}
                    isValid={cpf.isValid(numberMask(cpfNumber))}
                    onChange={(e) => setCpfNumber(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">Por favor informe um CPF válido</Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col xs={12} lg={3}>
                <Form.Group controlId="formBirthdayDate">
                  <Form.Label>Data de nascimento:</Form.Label>
                  <div>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={birthdayDate || new Date()}
                      required={true}
                      onChange={(date) => setBirthdayDate(date)}
                      customInput={<MaskedInput mask="11/11/1111" placeholder="dd/mm/yyyy" />}
                    />
                  </div>
                  <Form.Control.Feedback type="invalid">Por favor, informe a data de nascimento</Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Button className="mt-4 mb-5" variant="outline-primary" size="lg" type="submit">
                  Validar Cartão
                </Button>
              </Col>
            </Row>
          </Form>
        </If>
      </Container>

      {loadingCardRecipent ? (
        <Row className="justify-content-md-center my-5">
          <Col md="auto" className="text-center">
            <Spinner animation="border" />
          </Col>
        </Row>
      ) : (
        <If condition={checkFormStep}>
          <Container className="mb-5 unlock-card-form">
            <Form noValidate validated={formSaveValidated} onSubmit={handleSave}>
              <Row>
                <Col md="8">
                  <Row className="mb-3">
                    <Col>
                      <Form.Label>Nome do Beneficiário:</Form.Label>
                      <Form.Control
                        disabled={true}
                        type="text"
                        value={cardRecipientData.name || ''}
                        onChange={(e) => handleEdit('name', e.target.value)}
                        maxLength="150"
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Form.Label>Número do Cartão:</Form.Label>
                      <Form.Control
                        disabled={true}
                        type="text"
                        value={cardRecipientData.code || ''}
                        onChange={(e) => handleEdit('code', e.target.value)}
                        maxLength="20"
                      />
                    </Col>

                    <Col>
                      <Form.Label>CPF:</Form.Label>
                      <Form.Control
                        as={MaskedInput}
                        required={cardRecipientData.type === 'Titular'}
                        mask="111.111.111-11"
                        disabled={cpf.isValid(numberMask(cardRecipientData.cpf)) ? true : false}
                        placeholder="___.___.___-__"
                        type="text"
                        value={cardRecipientData.cpf || ''}
                        onChange={(e) => handleEdit('cpf', e.target.value)}
                        isInvalid={cardRecipientData.cpf.length == 0 || !cpf.isValid(numberMask(cardRecipientData.cpf))}
                        isValid={cpf.isValid(numberMask(cardRecipientData.cpf))}
                        maxLength="14"
                      />
                      <Form.Control.Feedback type="invalid">Por favor informe um CPF válido</Form.Control.Feedback>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Input
                        label={cardRecipientData.type.trim() === 'Titular' ? 'Nome da mãe*:' : 'Nome da mãe:'}
                        errorMessage="Por favor informe o nome completo da mãe"
                        value={cardRecipientData?.nameMother?.toUpperCase() || ''}
                        onChange={(e) => handleEdit('nameMother', e.target.value)}
                        name="nameMother"
                        maxLength="150"
                        isInvalid={isInvalidNameMother()}
                        type="text"
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Input
                        label="E-mail:"
                        errorMessage="Favor informar um e-mail válido."
                        value={cardRecipientData.email || ''}
                        onChange={(e) => handleEdit('email', e.target.value)}
                        maxLength="150"
                        isInvalid={isEmailInvalid}
                        type="text"
                      />
                    </Col>
                  </Row>

                  <Row className="input-cep mb-3">
                    <Col>
                      <Input
                        as={MaskedInput}
                        className="zipcode"
                        mask="11111-111"
                        label="CEP*:"
                        type="text"
                        name="address.zipcode"
                        isInvalid={cepMask(cardRecipientData?.address?.zipcode)?.length < 9}
                        value={cardRecipientData?.address?.zipcode || ''}
                        onChange={(e) => handleEdit('address.zipcode', e.target.value)}
                        errorMessage="CEP inválido"
                        maxLength="9"
                        required={cardRecipientData.type === 'Titular'}
                      />
                      <Button className="icone-acoes-lock" onClick={() => searchCep()} title="Atualizar endereço">
                        {loadingSearchZipCode && <Spinner animation="border" size="sm" />}
                        {!loadingSearchZipCode && <i className="icone-search"></i>}
                      </Button>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Input
                        label="Endereço*:"
                        type="text"
                        value={cardRecipientData?.address?.street?.toUpperCase() || ''}
                        name="address.street"
                        isInvalid={
                          (cardRecipientData.type === 'Titular' && !cardRecipientData?.address?.street) || false
                        }
                        disabled={cardRecipientData.type !== 'Titular'}
                        onChange={(e) => handleEdit('address.street', e.target.value)}
                        maxLength="150"
                        errorMessage="Favor informar o Endereço."
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <Input
                        maxLength="10"
                        type="text"
                        label="Número*:"
                        isInvalid={
                          (cardRecipientData.type === 'Titular' && !cardRecipientData?.address?.number) || false
                        }
                        value={cardRecipientData?.address?.number || ''}
                        name="address.number"
                        onChange={(e) => handleEdit('address.number', e.target.value)}
                        errorMessage="Favor informar o Número."
                      />
                    </Col>

                    <Col>
                      <Input
                        label="Complemento:"
                        maxLength="40"
                        type="text"
                        value={cardRecipientData?.address?.complement?.toUpperCase() || ''}
                        name="address.complement"
                        onChange={(e) => handleEdit('address.complement', e.target.value)}
                      />
                    </Col>

                    <Col md="auto" className="mb-3 mb-lg-0">
                      <Input
                        maxLength="150"
                        label="Bairro*:"
                        type="text"
                        isInvalid={
                          (cardRecipientData.type === 'Titular' && !cardRecipientData?.address?.neighborhood) || false
                        }
                        disabled={cardRecipientData.type !== 'Titular'}
                        value={cardRecipientData?.address?.neighborhood?.toUpperCase() || ''}
                        name="address.neighborhood"
                        onChange={(e) => handleEdit('address.neighborhood', e.target.value)}
                        errorMessage="Favor informar o Bairro."
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md="auto" className="mb-3 mb-lg-0">
                      <Input
                        label="Cidade*:"
                        value={cardRecipientData?.address?.city?.toUpperCase() || ''}
                        name="address.city"
                        onChange={(e) => handleEdit('address.city', e.target.value)}
                        isInvalid={(cardRecipientData.type === 'Titular' && !cardRecipientData?.address?.city) || false}
                        disabled={cardRecipientData.type !== 'Titular'}
                        maxLength="150"
                        errorMessage="Favor informar a Cidade."
                      />
                    </Col>

                    <Col>
                      <Input
                        label="Estado*:"
                        type="text"
                        value={cardRecipientData?.address?.state?.toUpperCase() || ''}
                        onChange={(e) => handleEdit('address.state', e.target.value)}
                        name="address.state"
                        isInvalid={
                          (cardRecipientData.type === 'Titular' && !cardRecipientData?.address?.state) || false
                        }
                        disabled={cardRecipientData.type !== 'Titular'}
                        maxLength="50"
                        errorMessage="Favor informar o Estado."
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col xs={3} lg={2} className="mb-3 mb-lg-0">
                      <Form.Label>DDD:</Form.Label>
                      <Form.Control
                        maxLength="2"
                        type="text"
                        disabled={cardRecipientData.type !== 'Titular'}
                        value={cardRecipientData.address.phoneDDD || ''}
                        onChange={(e) => handleEdit('address.phoneDDD', e.target.value)}
                        isInvalid={isInvalidPhoneDDD()}
                      />
                      <Form.Control.Feedback type="invalid">DDD inválido</Form.Control.Feedback>
                    </Col>

                    <Col xs={9} lg={4}>
                      <Form.Label>Telefone:</Form.Label>
                      <Form.Control
                        type="text"
                        disabled={cardRecipientData.type !== 'Titular'}
                        value={cardRecipientData.address.phone || ''}
                        onChange={(e) => handleEdit('address.phone', e.target.value)}
                        maxLength="20"
                        isInvalid={isInvalidPhone()}
                      />
                      <Form.Control.Feedback type="invalid">Telefone inválido</Form.Control.Feedback>
                    </Col>

                    <Col xs={3} lg={2}>
                      <Form.Label>DDD:</Form.Label>
                      <Form.Control
                        maxLength="2"
                        type="text"
                        disabled={cardRecipientData.type !== 'Titular'}
                        value={cardRecipientData.address.cellPhoneDDD || ''}
                        onChange={(e) => handleEdit('address.cellPhoneDDD', e.target.value)}
                        isInvalid={isInvalidCellPhoneDDD()}
                      />
                      <Form.Control.Feedback type="invalid">DDD inválido</Form.Control.Feedback>
                    </Col>

                    <Col xs={9} lg={4}>
                      <Form.Label>Celular:</Form.Label>
                      <Form.Control
                        type="text"
                        disabled={cardRecipientData.type !== 'Titular'}
                        value={cardRecipientData.address.cellPhone || ''}
                        onChange={(e) => handleEdit('address.cellPhone', e.target.value)}
                        maxLength="20"
                        isInvalid={isInvalidCellPhoneNumber()}
                      />
                      <Form.Control.Feedback type="invalid">Celular inválido</Form.Control.Feedback>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {cardRecipientData.type === 'Titular' && (
                <>
                  <Row>
                    <Col xs={12} lg={8}>
                      <Form.Group controlId="dataUpdate">
                        <Form.Check
                          type="checkbox"
                          required={true}
                          label="Estou ciente que os novos dados informados substituirão os dados atuais e serão utilizados pela Unimed Curitiba para qualquer finalidade relacionada ao plano de saúde."
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} lg={8}>
                      <Form.Group controlId="mailAddress">
                        <Form.Check
                          type="checkbox"
                          required={true}
                          label="Estou ciente de que novo endereço será utilizado para envio de correspondências e boletos de cobrança das mensalidades."
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}

              <Row>
                <Col xs={12} lg={8}>
                  <div className="button-container">
                    <CustomButton
                      color="primary"
                      text="Desbloquear cartão"
                      iconAlign="right"
                      className="mt-2"
                      type="submit"
                    />
                  </div>
                </Col>
              </Row>
            </Form>
          </Container>
        </If>
      )}

      <CustomModal
        open={modalOpened}
        closeModal={() => setModalOpened(false)}
        size="sm"
        title="Desbloqueio de cartão"
        footer={{
          closeButton: true,
        }}
      >
        <div className="unlock-card__modal-container">
          <strong>{message}</strong>
        </div>
      </CustomModal>

      <CustomModal
        open={modalZipCodeOpened}
        closeModal={() => setModalZipCodeOpened(false)}
        size="lg"
        title={`Selecione o endereço para o CEP ${cardRecipientData.address.zipcode}`}
        footer={{
          closeButton: true,
        }}
      >
        <div className="unlock-card__modal-container p-3" style={{ display: 'flex', height: '80%' }}>
          <div className="table-responsive" style={{ marginBottom: '80px' }}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Rua</th>
                  <th>Bairro</th>
                  <th>Cidade</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {zipCodeList.length > 0 &&
                  zipCodeList.map((item, index) => (
                    <tr key={index} onClick={() => setSelectedZipCode(index)}>
                      <td>{item.street}</td>
                      <td>{item.neighborhood}</td>
                      <td>{item.locale}</td>
                      <td>{item.state}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </CustomModal>
    </div>
  )
}

export default DesbloqueioCartao
